function spreadDomain(min, max, numPoints) {
  if (numPoints <= 1) {
    return [min];
  }

  return Array.from(
    { length: numPoints },
    (_, i) => min + ((max - min) * i) / (numPoints - 1)
  );
}

export const getAnswerDomain = (
  answers,
  propName = 'value',
  numPoints = 2,
  defaultDomain = [0, 0]
) => {
  if (!answers?.length) {
    const min = +defaultDomain[0];
    const max = +defaultDomain[defaultDomain.length - 1];

    return spreadDomain(min, max, numPoints);
  }

  const initialBound = +answers[0][propName];

  const [min, max] = answers.reduce(
    (accumulator, answer) => {
      if (answer?.is_na) {
        return accumulator;
      }
      const answerValue = +answer[propName];

      return [
        Math.min(accumulator[0], answerValue),
        Math.max(accumulator[1], answerValue),
      ];
    },
    [initialBound, initialBound]
  );

  return spreadDomain(min, max, numPoints);
};
